export default {
	title: 'Interessen',
	url: 'interessen',
	no_description: 'Kein definiertes Ziel',
	context_worse: 'Negativ',
	context_best: 'Positiv',
	tabs: {
		filters: {
			title: 'Ansichtsfilter'
		},
		general: {
			title: 'Allgemein'
		},
		export: {
			title: 'Exportieren'
		},
		comments: {
			title: 'Verlauf'
		},
		bot: {
			title: 'KI'
		}
	},
	messages: {
		edit_stake: 'Interesse bearbeiten',
		create_stake: 'Neues Interesse erstellen'
	},
	onboarding: {
		title: 'Interessen überprüfen',
		description:
			'Die KI hat die strukturellen Interessen Ihres Themas identifiziert. Prüfen Sie, ob sie wirklich abbilden, was Sie verlieren oder gewinnen könnten, wenn nichts geschieht. Passen Sie an, entfernen oder ergänzen Sie nach Bedarf.'
	}
};
